import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import MotorHeader from '@/components/MotorHeader'
import MotorFooter from '@/components/MotorFooter'
import Paginate from 'vuejs-paginate'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueLazyload from 'vue-lazyload'
import moment from 'moment'
import vSelect from 'vue-select'

import 'vue-select/dist/vue-select.css'
import loading from '@/assets/images/bg.jpg'
import error from '@/assets/images/bg.jpg'

Vue.config.productionTip = false
Vue.component('MotorHeader', MotorHeader)
Vue.component('MotorFooter', MotorFooter)
Vue.component('Paginate', Paginate)
Vue.use(VueAxios, axios)
Vue.use(VueLazyload, {
  error,
  loading,
})
Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('MMMM DD, YYYY')
    }
})
Vue.component('v-select', vSelect)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
